import React, { useContext, useState } from 'react';
import { toast } from 'sonner';
import { Loader2, Paperclip } from 'lucide-react';
import { errorApi, TiendaApi } from './tiendaUtils';

export default function ReportarPago({ ordenId, onReportado }) {
  const tiendaApi = useContext(TiendaApi);
  const [abierto, setAbierto] = useState(false);
  const [referencia, setReferencia] = useState('');
  const [archivo, setArchivo] = useState(null);
  const [enviando, setEnviando] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    if (!referencia.trim() && !archivo) { toast.error('Escribe la referencia del pago o adjunta el comprobante'); return; }
    const form = new FormData();
    form.append('referencia', referencia.trim());
    if (archivo) form.append('comprobante', archivo);
    setEnviando(true);
    try {
      const r = await tiendaApi.reportarPago(ordenId, form);
      toast.success(r.data.mensaje);
      onReportado();
    } catch (err) {
      toast.error(errorApi(err, 'No se pudo enviar el reporte'));
    } finally {
      setEnviando(false);
    }
  };

  if (!abierto) {
    return (
      <button type="button" onClick={() => setAbierto(true)} className="w-full rounded-xl border border-[#27272A] py-3 text-sm font-medium text-zinc-200 transition-colors hover:border-[#C9A962]/50" data-testid="pago-ya-pague">
        Ya pagué, quiero reportar mi pago
      </button>
    );
  }
  return (
    <form onSubmit={enviar} className="space-y-3 rounded-xl border border-[#27272A] p-4" data-testid="pago-reportar-form">
      <label className="block text-xs text-zinc-400">
        Referencia o número de la transacción
        <input value={referencia} onChange={e => setReferencia(e.target.value)} maxLength={80} placeholder="Ej. 123456789"
          className="mt-1 w-full rounded-xl border border-[#27272A] bg-[#0A0A0A] px-4 py-3 text-sm text-white outline-none focus:border-[#C9A962]" data-testid="pago-referencia" />
      </label>
      <label className="flex cursor-pointer items-center gap-2 rounded-xl border border-dashed border-zinc-700 px-4 py-3 text-sm text-zinc-300 hover:border-[#C9A962]/50">
        <Paperclip className="h-4 w-4 text-[#C9A962]" />
        <span className="truncate">{archivo ? archivo.name : 'Adjuntar comprobante (opcional)'}</span>
        <input type="file" accept="image/jpeg,image/png,image/webp,application/pdf" className="hidden" onChange={e => setArchivo(e.target.files?.[0] || null)} data-testid="pago-comprobante" />
      </label>
      <button type="submit" disabled={enviando} className="flex w-full items-center justify-center gap-2 rounded-xl bg-white py-3 text-sm font-semibold text-black transition-colors hover:bg-zinc-200 disabled:opacity-60" data-testid="pago-reportar-enviar">
        {enviando && <Loader2 className="h-4 w-4 animate-spin" />}Enviar reporte de pago
      </button>
    </form>
  );
}
